﻿// Card image slider (.pltm-card-slider) arrows need to sit above Dawn's invisible whole-card
// "stretched link" (.card__heading a::after) to be clickable at all — see custom.css, .card__inner
// z-index rule. Elevating .card__inner to achieve that also lifts the plain photo pixels above that
// same stretched link, so a click anywhere on the photo besides an arrow would otherwise do nothing
// instead of navigating to the product. This restores that navigation explicitly in JS, while still
// letting the arrow buttons handle their own click (slide change) without navigating.
document.addEventListener('click', function (event) {
  var media = event.target.closest('.pltm-card-media, .pltm-card-slide');
  if (!media) return;
  if (event.target.closest('.slider-button')) return;

  var card = media.closest('.card');
  var link = card && card.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
  if (link && link.href) {
    window.location.href = link.href;
  }
});

// Block Dawn from updating the URL when a variant is selected
(function () {
  function blockVariantUrl(original) {
    return function (state, title, url) {
      if (url && String(url).includes('variant=')) return;
      return original.apply(history, arguments);
    };
  }
  history.pushState = blockVariantUrl(history.pushState);
  history.replaceState = blockVariantUrl(history.replaceState);
})();

document.addEventListener('DOMContentLoaded', function () {

  // Deselect all size options on product page load
  setTimeout(function () {
    document.querySelectorAll('.product-form input[type="radio"]').forEach(function (r) {
      r.checked = false;
    });
    document.querySelectorAll('.swatch-input__label--active').forEach(function (l) {
      l.classList.remove('swatch-input__label--active');
    });
  }, 80);

  // Lift product info panel above footer as you scroll into it — desktop only. Only matters
  // while the panel is fixed/floating (closed state); once an accordion opens, custom.css's
  // .pltm-any-open override switches it to static and ignores --info-lift's transform entirely,
  // so this can keep running unconditionally without needing to special-case that state.
  var info = document.querySelector('.product__info-wrapper');
  var footer = document.querySelector('.pltm-footer');

  if (info && footer && window.innerWidth > 749) {
    var rafPending = false;

    function adjustInfoPosition() {
      if (window.innerWidth <= 749) {
        info.style.removeProperty('--info-lift');
        return;
      }
      var footerTop = footer.getBoundingClientRect().top;
      var viewH = window.innerHeight;
      info.style.setProperty('--info-lift', (footerTop < viewH ? (viewH - footerTop) : 0) + 'px');
      rafPending = false;
    }

    function onScroll() {
      if (!rafPending) {
        rafPending = true;
        requestAnimationFrame(adjustInfoPosition);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    adjustInfoPosition();
  }

  // Sidebar strip — on any screen size: starts matching the hero banner's own actual rendered
  // height (not a vh/svh/dvh guess — the real getBoundingClientRect().height) so it reads as "part
  // of" the banner while it's fully in view, and grows 1:1 with scroll distance until it covers the
  // full viewport, at which point it behaves like a normal full-height fixed bar. This runs the
  // same on mobile and desktop now — no CSS viewport unit reliably matched the hero's real height
  // on iOS Safari, but reading the hero element's own rect directly always matches by definition.
  var stripEl = document.querySelector('.pltm-sidebar__strip');
  var hero = document.querySelector('[id$="__image_banner"] .banner');

  if (stripEl && hero) {
    var stripRafPending = false;

    function adjustStripHeight() {
      // offsetHeight rounds to the nearest integer, but the hero's real rendered height (from vh
      // units) is often fractional — rounding down left the strip a hair short of the hero's actual
      // bottom edge on some screens. Math.ceil on the fractional rect height guarantees the strip
      // is never shorter than the hero, only ever equal or a fraction of a pixel taller.
      var heroHeight = Math.ceil(hero.getBoundingClientRect().height);
      var target = Math.min(window.innerHeight, heroHeight + window.scrollY);
      stripEl.style.setProperty('--pltm-strip-height', target + 'px');
      stripRafPending = false;
    }

    function onStripScroll() {
      if (!stripRafPending) {
        stripRafPending = true;
        requestAnimationFrame(adjustStripHeight);
      }
    }

    window.addEventListener('scroll', onStripScroll, { passive: true });
    window.addEventListener('resize', onStripScroll, { passive: true });
    adjustStripHeight();
  }

  // Password/coming-soon page countdown timer
  var countdownEl = document.querySelector('.pltm-countdown');
  if (countdownEl) {
    var valueEl = countdownEl.querySelector('.pltm-countdown__value');
    var expiredText = countdownEl.dataset.expiredText || '';
    // Space-separated "YYYY-MM-DD HH:MM" isn't reliably parsed as local time across browsers —
    // swapping in "T" makes it valid ISO 8601, which every modern browser parses consistently.
    var target = new Date(countdownEl.dataset.target.replace(' ', 'T'));

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function updateCountdown() {
      var diff = target.getTime() - Date.now();
      if (isNaN(target.getTime()) || diff <= 0) {
        valueEl.textContent = expiredText;
        clearInterval(countdownInterval);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      valueEl.textContent = days + 'd ' + pad(hours) + 'h ' + pad(minutes) + 'm ' + pad(seconds) + 's';
    }

    updateCountdown();
    var countdownInterval = setInterval(updateCountdown, 1000);
  }

  // Password page — measure the footer's real height so the content section (which centers
  // itself within 100vh minus this value) never claims more room than actually leaves the footer
  // on screen. Re-measured on resize since the footer's height can change across breakpoints.
  var passwordFooterEl = document.querySelector('.password__footer');
  if (passwordFooterEl) {
    function setFooterHeightVar() {
      document.documentElement.style.setProperty(
        '--pltm-password-footer-height',
        passwordFooterEl.getBoundingClientRect().height + 'px'
      );
    }
    setFooterHeightVar();
    window.addEventListener('resize', setFooterHeightVar);
  }

  // Password entry modal — plain event delegation, no custom element / class inheritance
  // involved, so there's nothing here that can fail to construct and silently leave the toggle
  // non-functional. Native <details>/<summary> already opens/closes on its own with zero JS;
  // this only adds the X button and click-outside-to-close on top of that native behavior.
  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('.pltm-password-modal__close');
    if (closeBtn) {
      var details = closeBtn.closest('.pltm-password-modal');
      if (details) details.removeAttribute('open');
      return;
    }

    var openDetails = document.querySelector('.pltm-password-modal[open]');
    if (openDetails && !openDetails.contains(event.target)) {
      openDetails.removeAttribute('open');
    }
  });

  document.addEventListener('keyup', function (event) {
    if (event.code === 'Escape') {
      var openDetails = document.querySelector('.pltm-password-modal[open]');
      if (openDetails) openDetails.removeAttribute('open');
    }
  });

  // Info page accordions (collapsible-content section) — native <details>/<summary> snaps open/
  // closed instantly with no way to animate that through CSS alone, so this intercepts the toggle
  // and height-animates .accordion__content manually, matching the same feel as the product page's
  // SIZE/DESCRIPTION/SHIPPING accordions (.pltm-accordion) elsewhere on the site.
  document.querySelectorAll('.accordion > details').forEach(function (details) {
    var content = details.querySelector('.accordion__content');
    var summary = details.querySelector('summary');
    if (!content || !summary) return;

    content.style.overflow = 'hidden';
    content.style.height = details.open ? 'auto' : '0px';
    content.style.transition = 'height 0.22s cubic-bezier(0.4, 0, 0.2, 1)';

    var animating = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (animating) return;
      animating = true;

      if (details.open) {
        var startHeight = content.getBoundingClientRect().height;
        content.style.height = startHeight + 'px';
        requestAnimationFrame(function () {
          content.style.height = '0px';
        });
        content.addEventListener('transitionend', function handler() {
          details.open = false;
          content.removeEventListener('transitionend', handler);
          animating = false;
        });
      } else {
        details.open = true;
        var endHeight = content.scrollHeight;
        content.style.height = '0px';
        requestAnimationFrame(function () {
          content.style.height = endHeight + 'px';
        });
        content.addEventListener('transitionend', function handler() {
          content.style.height = 'auto';
          content.removeEventListener('transitionend', handler);
          animating = false;
        });
      }
    });
  });

});
